
import React from 'react';

export function ExclamationIcon(props) {
    return (
        <svg id={props.id} xmlns="http://www.w3.org/2000/svg" width="34.875" height="34.875" viewBox="0 0 34.875 34.875" fill="#F0564E">
            <path id="Icon_awesome-exclamation-circle" data-name="Icon awesome-exclamation-circle" d="M35.438,18A17.438,17.438,0,1,1,18,.563,17.437,17.437,0,0,1,35.438,18ZM18,21.516a3.234,3.234,0,1,0,3.234,3.234A3.234,3.234,0,0,0,18,21.516ZM14.929,9.89l.522,9.563a.844.844,0,0,0,.842.8h3.413a.844.844,0,0,0,.842-.8l.522-9.563A.844.844,0,0,0,20.228,9H15.772A.844.844,0,0,0,14.929,9.89Z" transform="translate(-0.563 -0.563)" />
        </svg>
    );
}